import request from '@/utilities/request'

// 训练任务列表
export function trainList(params) {
    return request({
      url: 'train/index',
      method: 'get',
      params
    })
}

// 训练任务添加
export function trainSave(data) {
    return request({
        url:"train/index",
        method:"post",
        data
    })
}

export function trainRankDetail(params){
    
    return request({
        url:"train/indexdetail/v2",
        method:"get",
        params
    })
}

export function getstutrainlog(params){
    return request({
        url:"train/getstutrainlog/v2",
        method:"get",
        params
    })
}

// 训练详情
export function trainDetail(param) {
    return request({
        url:"train/index/v2/"+param.id,
        method:"get",
        params:{class_id:param.class_id}
    })
}

// 删除训练
export function trainDel(id) {
    return request({
        url:"train/index/"+id,
        method:"delete"
    })
}

// 保存网关训练记录
export function saveStudentLog(data){
    return request({
        url:"train/student/log/v2",
        method:"post",
        data
    })
}

// 班级当日训练排名
export function rankDaily(params){
    return request({
        url:"train/rank/daily/v2",
        method:"get",
        params
    })
}

// 班级本学期训练排名
export function rankTerm(params){
    return request({
        url:"train/rank/term",
        method:"get",
        params
    })
}